import { render, staticRenderFns } from "./WaitingSubmission.vue?vue&type=template&id=f2930338&scoped=true&"
import script from "./WaitingSubmission.vue?vue&type=script&lang=js&"
export * from "./WaitingSubmission.vue?vue&type=script&lang=js&"
import style0 from "./WaitingSubmission.vue?vue&type=style&index=0&id=f2930338&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2930338",
  null
  
)

export default component.exports